<div class="widget">
  <div class="amSuite-widget-header">
    {{'widgets.activity-graphs.typology-graph.title' | translate}}
    @if (modify) {
      <a href="javascript:void(0)" (click)="actpop()" class="modify-btn"
        pTooltip="{{'widgets.user-activities.edit' | translate}}">
        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
      </a>
    }
    @if (!modify) {
      <small class="date-font"><i>({{ initialDate | dateMoment:shortDate }} -
        {{ finalDate | dateMoment:shortDate }})</i></small>
    }
  </div>
  @if (!modify) {
    <div class="graph-widget amSuite-widget-block">
      @switch (status) {
        @case ('ready') {
          <div class="chart-card-content">
            <p-chart type="bar" [height]="CanvasHeight+'px'" [data]="dataOfTypology" [options]="barOptions"></p-chart>
            <div class="legend-row">
              <span class="lg-item lg-open"><span class="lg-dot" aria-hidden="true"></span>{{ 'chart-view.label-opened' | translate }}</span>
              <span class="lg-item lg-work"><span class="lg-dot" aria-hidden="true"></span>{{ 'chart-view.label-working' | translate }}</span>
              <span class="lg-item lg-closed"><span class="lg-dot" aria-hidden="true"></span>{{ 'chart-view.label-closed' | translate }}</span>
            </div>
          </div>
        }
        @case ('busy') {
          <div style="display: flex; justify-content: center; align-items: center; min-height: 200px;">
            <p-progressSpinner strokeWidth="3" animationDuration="1s"></p-progressSpinner>
          </div>
        }
      }
    </div>
  }
</div>
